import { Link } from "react-scroll";

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-lightBlue text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div className="flex-1">
            <div className="flex items-center mb-6">
              <img
                className="h-12 cursor-pointer mr-4"
                src="./Logo.png"
                alt="Global Bau Logo"
              />
              <p className="text-white/70 text-sm">
                Ihr vertrauenswürdiger Partner für Innovation.
              </p>
            </div>
            <div className="space-y-2">
              <h3 className="text-lg font-semibold mb-3">
                Kontaktieren Sie uns
              </h3>
              <p className="text-white/80">Josefstr.10 51377 Leverkusen</p>
              <p className="text-white/80">Tel: 0173-4317404</p>
              <p className="text-white/80">
                E-Mail: Info@global-baugmbh.de
              </p>
            </div>
          </div>

          <div className="md:text-right">
            <h3 className="text-lg font-semibold mb-3">Schnellzugriff</h3>
            <nav>
              <ul className="space-y-2">
                {[
                  { to: "home", label: "Startseite" },
                  { to: "uber-uns", label: "Über uns" },
                  { to: "dienstleistungen", label: "Dienstleistungen" },
                  { to: "footer", label: "Kontakt" },
                ].map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      smooth={true}
                      duration={500}
                      className="text-white/70 hover:text-white transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        <div className="border-t border-white/20 mt-10 pt-6 text-center">
          <p className="text-white/60 text-sm">
            &copy; {new Date().getFullYear()} Global-Bau GmbH. Alle Rechte
            vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
}
